// RESET
export const RESET = 'RESET';

// UI
export const SET_HAS_ERROR = 'SET_HAS_ERROR';

// FILTERS
export const SET_FILTERS = 'SET_FILTERS';
export const SELECT_FILTER_IN_UI = 'SELECT_FILTER_IN_UI';
export const WBS_FILTER_SELECTION = 'WBS_FILTER_SELECTION';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_WBS_ITEMS = 'SET_WBS_ITEMS';
export const RESET_CLEAR_DATES_FLAG = 'RESET_CLEAR_DATES_FLAG';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';

// REGISTER
export const GETTING_DATA = 'GETTING_DATA';
export const GETTING_PREV_DATA = 'GETTING_PREV_DATA';
export const ERROR_GETTING_DATA = 'ERROR_GETTING_DATA';
export const SET_REGISTER = 'SET_REGISTER';
export const APPEND_TO_REGISTER = 'APPEND_TO_REGISTER';
export const CLEAR_REGISTER = 'CLEAR_REGISTER';
export const SET_REGISTER_ITEM_ACTIONS = 'SET_REGISTER_ITEM_ACTIONS';
export const DELETE_ITEM_FROM_REGISTER = 'DELETE_ITEM_FROM_REGISTER';
export const UPDATE_ITEM_IN_REGISTER = 'UPDATE_ITEM_IN_REGISTER';
export const PUSH_INSERT = 'PUSH_INSERT';
export const SET_APPROVALS_MODE = 'SET_APPROVALS_MODE';
export const SET_ARCHIVE_MODE = 'SET_ARCHIVE_MODE';
